const validateCoverImgs = (rule, value, callback) => {
  if (!Array.isArray(value) || !value.length || !value[0].url) {
    callback(new Error('请上传封面图片'))
    return
  }
  if (value.length > 1) {
    callback(new Error('封面图片最多1张'))
    return
  }
  callback()
}

const validateCustomerid = (form) => (rule, value, callback) => {
  if (Number(form.is_common) === 0 && !value) {
    callback(new Error('请选择所属客户'))
    return
  }
  callback()
}

export const createFormRules = (form) => ({
  title: [
    { required: true, message: '请输入标题' },
    { max: 255, message: '标题最多255个字符' },
  ],
  cover_imgs: [
    { required: true, validator: validateCoverImgs },
  ],
  target_usertype: [
    { required: true, message: '请选择所属用户类型' },
  ],
  display_in_app_learning_center: [
    { required: true, message: '请选择是否在App展示' },
  ],
  priority: [
    { required: true, message: '请输入优先级' },
  ],
  retraining_days: [
    { required: true, message: '请输入重考间隔', trigger: 'blur' },
  ],
  is_common: [
    { required: true, message: '请选择是否通用', trigger: 'change' },
  ],
  customerid: [
    { validator: validateCustomerid(form), trigger: 'change' },
  ],
  training_knowledge_id: [
    { required: true, message: '请选择所属知识库', type: 'number' },
  ],
  instruction_type: [
    { required: true, message: '请选择类型', trigger: 'change' },
  ],
})

export const createRelatedRules = (needsCourse, needsExam) => {
  const rules = {}
  if (needsCourse) {
    rules.training_course_id = [
      { required: true, message: '请选择关联教程', trigger: 'change' },
    ]
  }
  if (needsExam) {
    rules.training_examination_id = [
      { required: true, message: '请选择关联考试', trigger: 'change' },
    ]
  }
  return rules
}



// WEBPACK FOOTER //
// ./src/views/training/training-instruction.rules.js